import { BaseControlValueAccessor } from './base.accessor';
import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';
import { FormHelper } from '../utils';

export abstract class FormValueAccessor extends BaseControlValueAccessor<{}> {
  abstract group: FormGroup;

  writeValue(value: {}): void {
    if (value) {
      this.group.setValue(value, { emitEvent: false });
    }
  }

  override registerOnChange(fn: any): void {
    this.group.valueChanges.subscribe(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.group.disable();
    } else {
      this.group.enable();
    }
  }

  override validate(control: AbstractControl): ValidationErrors | null {
    return FormHelper.getValidationErrors(this.group);
  }
}
